const STORAGE_KEY = 'panelSize';
export const panelSize = {
  get(): any {
    const data: any = localStorage.getItem(STORAGE_KEY);
    return JSON.parse(data);
  },
  set(value: any): void {
    const data = JSON.stringify(value);
    localStorage.setItem(STORAGE_KEY, data);
  },
  getDefault(): any {
    return {
      fullWidth: false,
      width: 40,
    };
  },
};
